import { Address, ProviderRoleTypeEnum } from "@/services";

export type ReferringAgencyFormValues = {
  uuid?: string;
  agencyId: string;
  name: string;
  agencyType: string;
  npi: string;
  contactPerson: string;
  contactRole: string;
  phone: string;
  email: string;
  fax: string;
  address: Address;
  archive?: boolean;
};

export const REFERRING_AGENCY_INITIAL_VALUES: ReferringAgencyFormValues = {
  agencyId: "",
  name: "",
  agencyType: "",
  npi: "",
  contactPerson: "",
  contactRole: "",
  phone: "",
  email: "",
  fax: "",
  address: {
    line1: "",
    line2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  },
};

export type ReferringAgencyTextField = {
  name: Exclude<keyof ReferringAgencyFormValues, "address" | "archive">;
  label: string;
  required?: boolean;
};

export const REFERRING_AGENCY_DETAIL_FIELDS: ReferringAgencyTextField[] = [
  { name: "agencyId", label: "Agency ID", required: true },
  { name: "name", label: "Agency Name", required: true },
  { name: "agencyType", label: "Agency Type", required: true },
  { name: "npi", label: "NPI" },
];

export const REFERRING_AGENCY_CONTACT_FIELDS: ReferringAgencyTextField[] = [
  { name: "contactPerson", label: "Contact Person", required: true },
  { name: "contactRole", label: "Contact Role", required: true },
  { name: "email", label: "Email Address" },
];

export const REFERRING_AGENCY_SECTION = {
  AGENCY_DETAILS: "Agency Details",
  CONTACT_DETAILS: "Contact Details",
};

export const REFERRING_AGENCY_TITLE = {
  ADD: "Add Referring Agency",
  EDIT: "Edit Referring Agency",
};

export const REFERRING_AGENCY_ACTION = {
  EDIT: "edit",
  ARCHIVE: "archive",
  RESTORE: "restore",
} as const;

export const REFERRING_AGENCY_ADD_ROLES: string[] = [
  ProviderRoleTypeEnum.PracticeAdmin,
  ProviderRoleTypeEnum.FrontDeskStaff,
];

export const REFERRING_AGENCY_QUERY_KEY = {
  LIST: "referring-agency-list",
  DETAIL: "referring-agency-detail",
} as const;

export const PHONE_MASK = "(999) 999-9999";
export const PHONE_MASKED_LENGTH = 14;
export const NPI_REGEX = /^\d{10}$/;

export const ALPHANUMERIC_TEXT_REGEX = /^[A-Za-z0-9_\- ]+$/;
export const LETTERS_ONLY_REGEX = /^[A-Za-z ]+$/;

export const REFERRING_AGENCY_FIELD_LENGTH = {
  AGENCY_ID: { min: 2, max: 20 },
  NAME: { min: 2, max: 60 },
  AGENCY_TYPE: { min: 2, max: 50 },
  CONTACT_PERSON: { min: 2, max: 60 },
  CONTACT_ROLE: { min: 2, max: 50 },
} as const;

export const ALPHANUMERIC_TEXT_MESSAGE =
  "Only letters, numbers, hyphen (-) and underscore (_) are allowed";
export const LETTERS_ONLY_MESSAGE = "Only letters are allowed";

export const REFERRING_AGENCY_MESSAGES = {
  ADDED: "Referring agency added successfully",
  UPDATED: "Referring agency updated successfully",
  ARCHIVED: "Referring agency archived successfully",
  RESTORED: "Referring agency restored successfully",
  DISCARD: "You have unsaved changes. Are you sure you want to discard them?",
  ARCHIVE: "You want to archive this referring agency",
  RESTORE: "You want to restore this referring agency",
  PHONE_INVALID: "Enter a valid 10 digit phone number",
  FAX_INVALID: "Enter a valid 10 digit fax number",
  NPI_INVALID: "NPI must be exactly 10 digits",
  INACTIVATE: "You want to inactivate this referring agency",
  ARCHIVE_DISABLED: "Deactivate the referring agency before archiving it",
  NO_RESULTS: "No results found",
  LOAD_FAILED: "Unable to load referring agencies. Please try again.",
};
